import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { saveAuditNote } from "../../CroActions";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

/**
 * Controlled modal for posting a manual history note. Container owns the
 * open/closed flag; this component owns the in-flight text, posting state
 * and error. Calls {@code onSaved()} after a successful POST so the parent
 * can refresh its grid.
 *
 * Props:
 *  - open: boolean — controls visibility
 *  - target: {entityType, entityId} — which entity the note attaches to
 *  - auth: login info (uses {@code auth.startUrl})
 *  - dispatch: redux dispatch (passed straight to the fetch wrapper)
 *  - onClose(): close without saving
 *  - onSaved(): close + tell parent to refresh
 */
class AuditHistoryNoteDialog extends Component {
  state = { text: "", posting: false, error: null };

  save = () => {
    const { auth, target, dispatch, onSaved } = this.props;
    const text = (this.state.text || "").trim();
    if (!text || !target) return;
    this.setState({ posting: true, error: null });
    saveAuditNote(auth.startUrl, {
      entityType: target.entityType,
      entityId: target.entityId,
      text,
    }, dispatch)
      .then(() => {
        this.setState({ posting: false, text: "" });
        if (typeof onSaved === "function") onSaved();
      })
      .catch((err) =>
        this.setState({
          posting: false,
          error: "Poznámku se nepodařilo uložit: " + (err && err.message ? err.message : err),
        }),
      );
  };

  close = () => {
    if (this.state.posting) return;
    this.props.onClose && this.props.onClose();
  };

  render() {
    const { open, target } = this.props;
    if (!target) return null;
    const { text, posting, error } = this.state;
    return (
      <Dialog open={!!open} onClose={this.close} maxWidth="sm" fullWidth>
        <DialogTitle>Přidat poznámku do historie</DialogTitle>
        <DialogContent>
          <textarea
            value={text}
            onChange={(e) => this.setState({ text: e.target.value })}
            rows={4}
            maxLength={255}
            style={{ width: "100%", boxSizing: "border-box", marginTop: 8 }}
            placeholder="Text poznámky (např. telefon, e-mail, doplnění…)"
          />
          <div style={{ textAlign: "right", fontSize: 12, color: text.length >= 255 ? "red" : "#666", marginTop: 2 }}>
            {text.length}/255
          </div>
          {error && <div style={{ color: "red", marginTop: 4 }}>{error}</div>}
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            style={{ ...styles.buttons, marginRight: 8 }}
            label={posting ? "Ukládám…" : "Uložit"}
            disabled={posting || !text.trim()}
            onClick={this.save}
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            disabled={posting}
            onClick={this.close}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default AuditHistoryNoteDialog;
